import { Component, inject, type OnInit } from "@angular/core";
import { AnalyticsService } from "@cariloop/analytics";

export enum CreateAccountSteps {
  Welcome = "welcome",
  Coaching = "coaching",
  Tools = "tools",
  Community = "community",
  Resources = "resources",
  Security = "security",
  Ready = "ready",
}

export type slide = {
  step: CreateAccountSteps;
  title: string;
  paragraph: string;
  alt?: string;
  imgSrc: string;
};

@Component({
  selector: "app-introduction",
  templateUrl: "introduction.component.html",
  styleUrls: ["introduction.component.scss"],
  standalone: false,
})
export class IntroductionComponent implements OnInit {
  currentSlide = 0;
  isFirstStep = true;
  isTwoButtons = true;
  isFinalStep = false;
  readonly #analyticsService = inject(AnalyticsService);

  slides: slide[] = [
    {
      step: CreateAccountSteps.Welcome,
      title: "INTRODUCTION.WELCOME",
      paragraph: "INTRODUCTION.WELCOME_PARAGRAPH",
      alt: "INTRODUCTION.SPLASH_ALT",
      imgSrc: "assets/img/Splash.png",
    },
    {
      step: CreateAccountSteps.Coaching,
      title: "INTRODUCTION.COACHING",
      paragraph: "INTRODUCTION.COACHING_PARAGRAPH",
      alt: "INTRODUCTION.COACHING_ALT",
      imgSrc: "assets/img/Coaching.png",
    },
    {
      step: CreateAccountSteps.Tools,
      title: "INTRODUCTION.TOOLS",
      paragraph: "INTRODUCTION.TOOLS_PARAGRAPH",
      alt: "INTRODUCTION.TOOlS_ALT",
      imgSrc: "assets/img/Tools.png",
    },
    {
      step: CreateAccountSteps.Community,
      title: "INTRODUCTION.COMMUNITY",
      paragraph: "INTRODUCTION.COMMUNITY_PARAGRAPH",
      alt: "INTRODUCTION.COMMUNITY_ALT",
      imgSrc: "assets/img/Community.png",
    },
    {
      step: CreateAccountSteps.Resources,
      title: "INTRODUCTION.RESOURCES",
      paragraph: "INTRODUCTION.RESOURCES_PARAGRAPH",
      alt: "INTRODUCTION.RESOURCES_ALT",
      imgSrc: "assets/img/Resources.png",
    },
    {
      step: CreateAccountSteps.Security,
      title: "INTRODUCTION.SECURITY",
      paragraph: "INTRODUCTION.SECURITY_PARAGRAPH",
      alt: "INTRODUCTION.SECCURITY_ALT",
      imgSrc: "assets/img/Security.png",
    },
    {
      step: CreateAccountSteps.Ready,
      title: "INTRODUCTION.READY",
      paragraph: "INTRODUCTION.READY_PARAGRAPH",
      imgSrc: "assets/img/intro-background.png",
    },
  ];

  ngOnInit(): void {
    this.#analyticsService.trackEvent("register-welcome-viewed");
  }

  onPreviousClick() {
    const previous = this.currentSlide - 1;
    this.currentSlide = previous < 0 ? this.slides.length - 1 : previous;
    if (this.currentSlide === 0) {
      this.isFirstStep = true;
      this.isTwoButtons = true;
    }
    if (this.currentSlide === 5) {
      this.isFinalStep = false;
      this.isTwoButtons = false;
    }
  }

  onNextClick() {
    if (this.currentSlide === 0) {
      this.#analyticsService.trackEvent("register-welcome-get-started");
      this.#analyticsService.trackEvent("register-welcome-carousel-viewed");
    } else {
      this.#analyticsService.trackEvent("register-welcome-carousel-next", {
        step: this.slides[this.currentSlide].step,
      });
    }
    const next = this.currentSlide + 1;
    if (next === this.slides.length) {
      return this.onCreateAccount();
    }

    this.currentSlide = next;
    if (this.currentSlide === 1) {
      this.isFirstStep = false;
      this.isTwoButtons = false;
    }
    if (this.currentSlide === 6) {
      this.isFinalStep = true;
      this.isTwoButtons = true;
    }
  }

  onCreateAccount() {
    localStorage.setItem("cariloop:createaccountClicked", "true");
    localStorage.setItem("cariloop:introductionSeen", "true");
    this.reloadPage();
  }

  onSkip() {
    localStorage.setItem("cariloop:introductionSkipped", "true");
    localStorage.setItem("cariloop:introductionSeen", "true");
    this.reloadPage();
  }

  reloadPage() {
    window.location.reload();
  }
}
